import HomeCardPlaceHolder from '@spotahome/marketplace-common/src/components/Homecard/HomeCardPlaceHolder';
import { useMediaQuery } from '@spotahome/ui-library/src/tenant/components/utils/breakpoints/breakpoints';

const EMPTY_LIST_LENTGH_BY_DEVICE = {
  default: 8,
  desktop: 12,
  wide: 12
};

const EmptyList = () => {
  const { device } = useMediaQuery();
  const emptyListLength =
    EMPTY_LIST_LENTGH_BY_DEVICE[device] || EMPTY_LIST_LENTGH_BY_DEVICE.default;
  return (
    <div className="l-list" style={{ margin: 0 }}>
      {new Array(emptyListLength).fill().map((_, i) => (
        <div className="l-list__item" key={i}>
          <HomeCardPlaceHolder />
        </div>
      ))}
    </div>
  );
};

export default EmptyList;
